import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { CookieService } from 'ngx-cookie-service'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { NgSelectModule } from '@ng-select/ng-select'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker';

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { IndexComponent } from './index/index.component'
import { DetailComponent } from './detail/detail.component'
import { MenuComponent } from './menu/menu.component'

import { TokenInterceptor } from './token.interceptor'
import { BuildNumberComponent } from './build-number/build-number.component'
import { AddButtonComponent } from './add-button/add-button.component'
import { HelpButtonComponent } from './help-button/help-button.component'
import { HelpMessageComponent } from './help-message/help-message.component'
import { LoadingComponent } from './loading/loading.component'
import { FiltersComponent } from './filters/filters.component'
import { RedirectToDashboardComponent } from './redirect-to-dashboard/redirect-to-dashboard.component';
import { EditButtonComponent } from './edit-button/edit-button.component'
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { SaveButtonComponent } from './save-button/save-button.component';
import { CancelButtonComponent } from './cancel-button/cancel-button.component';
import { OpenButtonComponent } from './open-button/open-button.component';
import { OpenButtonSmComponent } from './open-button-sm/open-button-sm.component';
import { CancelButtonSmComponent } from './cancel-button-sm/cancel-button-sm.component';
import { SaveButtonSmComponent } from './save-button-sm/save-button-sm.component';
import { DisplayBoxComponent } from './display-box/display-box.component';
import { CourseComponent } from './course/course.component';
import { CollapseButtonComponent } from './collapse-button/collapse-button.component';
import { ButtonStatusComponent } from './button-status/button-status.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ProgressComponent } from './progress/progress.component';
import { FileSelectComponent } from './file-select/file-select.component';
import { LoadMoreComponent } from './load-more/load-more.component';
import { CourseSessionsComponent } from './course-sessions/course-sessions.component';
import { CourseVendorsComponent } from './course-vendors/course-vendors.component';
import { CourseObjectivesComponent } from './course-objectives/course-objectives.component'
import { CourseObjectiveComponent } from './course-objective/course-objective.component'
// import { CourseCreditsComponent } from './course-credits/course-credits.component';
// import { CourseEvaluationOptionsComponent } from './course-evaluation-options/course-evaluation-options.component';
// import { CourseCertificateOptionsComponent } from './course-certificate-options/course-certificate-options.component';
import { CourseRegistrationsComponent } from './course-registrations/course-registrations.component';
import { CourseRegistrationComponent } from './course-registration/course-registration.component';
import { CourseRegistrantComponent } from './course-registrant/course-registrant.component';
// import { CourseLogsComponent } from './course-logs/course-logs.component';
import { AddButtonSmComponent } from './add-button-sm/add-button-sm.component';
import { CourseSessionComponent } from './course-session/course-session.component';
import { ReloadButtonSmComponent } from './reload-button-sm/reload-button-sm.component';
import { EditButtonSmComponent } from './edit-button-sm/edit-button-sm.component';
import { MoveUpButtonSmComponent } from './moveup-button-sm/moveup-button-sm.component'
import { MoveDownButtonSmComponent } from './movedown-button-sm/movedown-button-sm.component'
import { PreviewButtonComponent } from './preview-button/preview-button.component';
import { PreviewButtonSmComponent } from './preview-button-sm/preview-button-sm.component';
import { LandingPageComponent } from './landing-page/landing-page.component'
import { LandingPageCourseSessionsComponent } from './landing-page-course-sessions/landing-page-course-sessions.component';
import { LandingPageCourseSessionComponent } from './landing-page-course-session/landing-page-course-session.component';
import { LandingPageCourseVendorsComponent } from './landing-page-course-vendors/landing-page-course-vendors.component';
import { CourseVendorComponent } from './course-vendor/course-vendor.component';
import { LandingPageCourseVendorComponent } from './landing-page-course-vendor/landing-page-course-vendor.component';
// import { CommunicationOptionsComponent } from './communication-options/communication-options.component';
import { PresentationButtonComponent } from './presentation-button/presentation-button.component';
import { SocialButtonComponent } from './social-button/social-button.component';
import { DeleteButtonSmComponent } from './delete-button-sm/delete-button-sm.component';
import { ReportsButtonComponent } from './reports-button/reports-button.component'
import { ReportsComponent } from './reports/reports.component'
import { ReportsParsComponent } from './reports-pars/reports-pars.component'
import { ReportsParsIndividualComponent } from './reports-pars-individual/reports-pars-individual.component'
import { NgxSpinnerModule } from 'ngx-spinner'

@NgModule({
    declarations: [
        AppComponent,
        IndexComponent,
        DetailComponent,
        MenuComponent,
        BuildNumberComponent,
        AddButtonComponent,
        HelpButtonComponent,
        HelpMessageComponent,
        LoadingComponent,
        FiltersComponent,
        RedirectToDashboardComponent,
        EditButtonComponent,
        DeleteButtonComponent,
        SaveButtonComponent,
        CancelButtonComponent,
        OpenButtonComponent,
        OpenButtonSmComponent,
        CancelButtonSmComponent,
        SaveButtonSmComponent,
        DisplayBoxComponent,
        CourseComponent,
        CollapseButtonComponent,
        ButtonStatusComponent,
        FileUploadComponent,
        ProgressComponent,
        FileSelectComponent,
        LoadMoreComponent,
        CourseSessionsComponent,
        CourseVendorsComponent,
        CourseObjectivesComponent,
        CourseObjectiveComponent,
        // CourseCreditsComponent,
        // CourseEvaluationOptionsComponent,
        // CourseCertificateOptionsComponent,
        CourseRegistrationsComponent,
        CourseRegistrationComponent,
        CourseRegistrantComponent,
        // CourseLogsComponent,
        AddButtonSmComponent,
        CourseSessionComponent,
        ReloadButtonSmComponent,
        EditButtonSmComponent,
        MoveUpButtonSmComponent,
        MoveDownButtonSmComponent,
        PreviewButtonComponent,
        PreviewButtonSmComponent,
        LandingPageComponent,
        LandingPageCourseSessionsComponent,
        LandingPageCourseSessionComponent,
        LandingPageCourseVendorsComponent,
        CourseVendorComponent,
        LandingPageCourseVendorComponent,
        // CommunicationOptionsComponent,
        PresentationButtonComponent,
        SocialButtonComponent,
        DeleteButtonSmComponent,
        ReportsButtonComponent,
        ReportsComponent,
        ReportsParsComponent,
        ReportsParsIndividualComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        InfiniteScrollModule,
        NgSelectModule,
        BrowserAnimationsModule,
        A2Edatetimepicker,
        NgxSpinnerModule
    ],
    providers: [
        CookieService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
